document.addEventListener('click', function (event) {
  const thumb = event.target.closest('[data-ts-thumb]');
  if (!thumb) return;
  const root = thumb.closest('[data-ts-product-gallery]');
  if (!root) return;
  const main = root.querySelector('[data-ts-main-image]');
  const src = thumb.getAttribute('data-image-src');
  const alt = thumb.getAttribute('data-image-alt') || '';
  if (main && src) {
    main.src = src;
    main.alt = alt;
  }
});
